import { gql } from '@apollo/client/core';

const ConnectionsQuery = gql`
  query Connections {
    connectionRequestsInbox {
      edges {
        node {
          id
          createdAt
          read
          status
          requestor: requestee {
            firstName: firstname
            lastName: lastname
            avatarUrl
            slug
          }
        }
      }
      totalCount
    }
  }
`;

export default ConnectionsQuery;
